import React from 'react'
import { Button } from '@surecompanies/core_components'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import {
  TaskBanner,
  TaskBannerBody,
  TaskBannerHeading,
  TaskBannerIcon,
  TaskList,
  TaskRow,
} from './ClientBillingProfileManagement.styles'
import type { SyncTask, SyncTaskKey } from './hubspotSync.helpers'

interface HubspotSyncTaskBannerProps {
  heading: string
  tasks: SyncTask[]
  onOpenTask: (key: SyncTaskKey) => void
  onDismiss: () => void
}

/**
 * What a finished sync left behind: one line per decision, each opening where
 * it is made.
 */
const HubspotSyncTaskBanner = ({
  heading,
  tasks,
  onOpenTask,
  onDismiss,
}: HubspotSyncTaskBannerProps) => (
  <TaskBanner role="status">
    <TaskBannerIcon>
      <ExclamationCircleOutlined />
    </TaskBannerIcon>
    <TaskBannerBody>
      <TaskBannerHeading>
        <span>{heading}</span>
        <Button type="link" size="small" onClick={onDismiss}>
          Dismiss
        </Button>
      </TaskBannerHeading>
      {tasks.length > 0 ? (
        <TaskList>
          {tasks.map((task) => (
            <TaskRow key={task.key}>
              <span>{task.label}</span>
              <Button
                type="link"
                size="small"
                onClick={() => onOpenTask(task.key)}
              >
                View
              </Button>
            </TaskRow>
          ))}
        </TaskList>
      ) : null}
    </TaskBannerBody>
  </TaskBanner>
)

export { HubspotSyncTaskBanner }
